export default "__VITE_ASSET__DqWkAL5L__"